<template>
  <div class="pb-default-item-wrapper">
    <PbItem
      v-tooltip="{ text: tooltip }"
      v-bind="$attrs"
      button
      :class="{
        'pb-default-item': true,
        'pb-default-item-extended': extended,
      }"
      :icon="icon"
      @click.prevent="click"
    >
      {{ item.name }}
      <PbItemDetails
        v-if="item._color"
        v-tooltip="{ text: colorTooltip }"
      >
        {{ item._color.index }}
      </PbItemDetails>
      <PbItemDetails v-if="item._type === 'ssl.channel' && showBeams">
        {{ itemDetails }}
      </PbItemDetails>
    </PbItem>
  </div>
</template>

<script setup>
import { computed, toRef } from 'vue'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'
import PbItem from '@/components/PbItem/PbItem.vue'
import { getIcon as getPresetIcon } from '@/helpers/profile/presets'
import { getIcon as getChannelIcon } from '@/helpers/profile/channels'
import useChannelDetails from '@/composables/useChannelDetails'
import PbItemDetails from '@/components/PbItemDetails/PbItemDetails.vue'

defineOptions({
  compatConfig: {
    MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
  inheritAttrs: false,
})

const props = defineProps({
  item: { type: Object, required: true },
  action: { type: String, default: '' },
  showBeams: { type: Boolean, default: false },
  extended: { type: Boolean, default: false },
})

const emit = defineEmits(['click'])

const icon = computed(() => {
  if (props.item._type === 'ssl.preset') {
    return getPresetIcon(props.item)
  }
  return getChannelIcon(props.item)
})

const colorTooltip = computed(() => {
  const color = props.item._color
  return color ? `${color.family} ${color.index}` : null
})

const tooltip = computed(() => {
  const color = colorTooltip.value
  const name = color ? `${color}: ${props.item.name}` : props.item.name
  return props.action ? `${props.action} \u0022${name}\u0022` : name
})

const itemDetails = useChannelDetails(toRef(props, 'item'))

function click() {
  emit('click', props.item)
}
</script>

<style lang="scss" src="./PbDefaultItem.scss" />
